// MIT License - Copyright (c) 2026 Doug McNall - See .kiro/steering/general/development-standards.md for full license

/**
 * Universe Digiworld - Main Export
 * 
 * Aggregates all configuration for the Digital World universe.
 * A parallel digital dimension where data streams form landscapes
 * and Digimon evolve and devolve.
 */

import { starSystems, starPositions } from './StarSystemsConfig';
import { warpGates, warpGatePositions } from './WarpGatesConfig';
import { DigiworldAliensPlanets } from './AliensConfig';

export const universeDigiworld = {
  id: 'digiworld',
  starSystems,
  starPositions,
  warpGates,
  warpGatePositions,
  aliens: DigiworldAliensPlanets,
};

export default universeDigiworld;